<template>
    <div>    
        <section class="hero">    
            <div class="hero-body">    
                <div class="container">    
                    <h1 class="title">    
                        Hero title    
                    </h1>    
                    <h2 class="subtitle">    
                        Hero subtitle    
                    </h2>    
                </div>    
            </div>    
        </section>    
        <div class="container">    
            <div class="columns is-multiline">    
                <div class="column is-one-quarter" v-for="dish in dishes" :key="dish.id">    
                    <div class="recipe-card card">    
                        <div class="card-image">    
                <router-link :to="{name: 'dish', params: {id: dish.id, slug: dish.slug}}">
                                <div v-if="dish.mainImage" v-bind:style="{     
                                  'background-image': 'url(https://firebasestorage.googleapis.com/v0/b/mymeatloaf-app.appspot.com/o/' + recipe.mainImage[0] + '?alt=media)',    
                                  'background-repeat': 'no-repeat',    
                                  'background-position': 'center',    
                                  'background-size': 'cover',    
                                  'height': '150px'          
                                  }" />  
                                  <div v-else v-bind:style="{     
                                  'background-image': 'url(https://firebasestorage.googleapis.com/v0/b/mymeatloaf-app.appspot.com/o/' + dish.recipes[0].mainImage[0] + '?alt=media)',    
                                  'background-repeat': 'no-repeat',    
                                  'background-position': 'center',    
                                  'background-size': 'cover',    
                                  'height': '150px'          
                                  }" />           
                            </router-link>    
                        </div>    
                        <div class="card-content">    
                            <div class="media">    
                                <div class="media-left">    
                                    <figure class="image is-48x48">    
                                        <img src="https://bulma.io/images/placeholders/96x96.png" alt="Placeholder image">
                                    </figure>    
                                </div>    
                                <div class="media-content">                                    
                                    <p class="title is-4">
                                    <router-link :to="{name: 'dish', params: {id: dish.id, slug: dish.slug}}">
                                    {{dish.name}}
                                    </router-link> 
                                    </p>                                  
                                    <p class="">Made by <strong>{{dish.kitchen_name}}</strong></p>    
                                </div>    
                            </div>    
                            <div class="content">    
                                {{dish.subtitle}}    
                                <b-taglist>    
                                    <b-tag type="is-dark" v-for="tag in recipe.tags" :key="tag.id">#{{tag}}</b-tag>    
                                </b-taglist>    
                                <time datetime="2016-1-1">{{ dish.created_at.toDate() | moment("from", "now") }}</time>    
                            <b-dropdown aria-role="list" class="is-pulled-right" trap-focus>
                                <button class="button is-primary" slot="trigger">
                                    <b-icon icon="plus"></b-icon>
                                </button>
                                <b-dropdown-item aria-role="listitem" :focusable="false" custom>
                                <h2>Meals</h2>
                                </b-dropdown-item>
                                <b-dropdown-item aria-role="listitem" v-for="dish in dishes" :key="dish.id" @click="selectMeal({ recipe:recipe, dish_id:dish.id })">
                                {{dish.name}}
                                </b-dropdown-item>
                                <b-dropdown-item aria-role="listitem" :focusable="false" custom paddingless>
                                    <b-collapse class="card" aria-id="contentForNewMeal" :open="false" position="is-bottom">
                                        <div
                                            slot="trigger" 
                                            class="card-header"
                                            role="button"
                                            aria-controls="contentForNewMeal">
                                            <b-button type="is-primary" icon-right="plus"  style="width:100%;" />
                                        </div>
                                        <div class="card-content">
                                            <div class="content">
                                                <b-field label="Meal Name" class="add-meal-input">
                                                    <b-input v-model="newMealName"></b-input>
                                                </b-field>
                                                <b-field label="Meal Subtitle" class="add-meal-input">
                                                    <b-input v-model="newMealSubtitle"></b-input>
                                                </b-field>
                                            </div>
                                        </div>
                                        <footer class="card-footer">
                                            <a class="card-footer-item" @click="newMeal(recipe)">Save</a>
                                            <a class="card-footer-item">Edit</a>
                                            <a class="card-footer-item">Delete</a>
                                        </footer>
                                    </b-collapse>
                                </b-dropdown-item>
                            </b-dropdown>
                            </div>    
                        </div>    
                    </div>    
                </div>    
            </div>    
        </div>    
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
export default {
    mounted() {
        this.init();
    },
    computed: mapState('dishes', ['dishes','user']),
    methods: mapActions('dishes', ['init']),
};
</script>